module.exports = __webpack_public_path__ + "img/Silverman-Case-Brief.117ff590.png";